__turbopack_context__.v({
  "contentGrid": "countryToolFormat-module__rVl6dG__contentGrid",
  "contentGridNoFlag": "countryToolFormat-module__rVl6dG__contentGridNoFlag",
  "emptyState": "countryToolFormat-module__rVl6dG__emptyState",
  "emptyText": "countryToolFormat-module__rVl6dG__emptyText",
  "emptyTitle": "countryToolFormat-module__rVl6dG__emptyTitle",
  "flagImg": "countryToolFormat-module__rVl6dG__flagImg",
  "flagWrap": "countryToolFormat-module__rVl6dG__flagWrap",
  "infoLabel": "countryToolFormat-module__rVl6dG__infoLabel",
  "infoList": "countryToolFormat-module__rVl6dG__infoList",
  "infoRow": "countryToolFormat-module__rVl6dG__infoRow",
  "infoValue": "countryToolFormat-module__rVl6dG__infoValue",
  "infoValueEmpty": "countryToolFormat-module__rVl6dG__infoValueEmpty",
  "resultCard": "countryToolFormat-module__rVl6dG__resultCard",
  "resultHeader": "countryToolFormat-module__rVl6dG__resultHeader",
  "resultSub": "countryToolFormat-module__rVl6dG__resultSub",
  "resultTitle": "countryToolFormat-module__rVl6dG__resultTitle",
  "searchCard": "countryToolFormat-module__rVl6dG__searchCard",
  "searchInputWrap": "countryToolFormat-module__rVl6dG__searchInputWrap",
  "searchLabel": "countryToolFormat-module__rVl6dG__searchLabel",
  "wrapper": "countryToolFormat-module__rVl6dG__wrapper",
});
